export const SIGNIN_ROUTE: string = "/signin";
export const FORGOTPASSWORD_ROUTE: string = "/forgotpassword";
export const SIDEBAR_ROUTE: string = "/sidebar";
export const DASHBOARD_ROUTE: string = "/dashboard";
export const INVOICE_ROUTE: string = "/invoices";
export const INVOICEPREVIEW_ROUTE: string = "/invoice-details";
export const SUPPLIER_SITE_ROUTE: string = "/suppliers/details";
export const INVOICE_PREVIEW_ROUTE: string = "/invoice-preview";
export const MYTEAM_ROUTE: string = "/users";
export const SUPPLIERMANAGEMENT_ROUTE: string = "/suppliers";
export const MYCLIENTS_ROUTE: string = "/clients";
export const SETTINGS_ROUTE: string = "/administration";
export const METRICSINVOICE_ROUTE: string = "/metrics";
export const PROFILE_ROUTE: string = "/profile";
export const AUTHENTIFICATION_ROUTE: string = "/authentification";
export const SIGNUP_ROUTE: string = "/signup";
export const UPLOAD_INVOICE_ROUTE: string = "/upload-invoice";
export const UPDATE_PASSWORD_ROUTE: string = "/update-password";
export const REGISTERED_ROUTE: string = "/registered";
export const VERIFY_EMAIL_ROUTE: string = "/verifyemail";
export const ADD_SUPPLIER: string = "/suppliers/documents";
export const NOTIFICATION_ROUTE: string = "/notification";
export const SSO_CALLBACK_ROUTE: string = "/auth/callback";
export const INBOX_ROUTE: string = "/inbox";

// Expense Module
export const EXPENSES_ROUTE: string = "/expenses";
export const EXPENSES_MINE_ROUTE: string = "/expenses/mine";
export const EXPENSES_PENDING_ROUTE: string = "/expenses/pending";
export const EXPENSES_SUBMIT_ROUTE: string = "/expenses/submit";
export const EXPENSES_DETAIL_ROUTE: string = "/expenses/:claimId";
export const expenseDetailRoute = (claimId: number | string): string => `/expenses/${claimId}`;
